import { Block } from '@/components/base/Block'
import { Text3 } from '@/components/base/Text'
import AdvisorCommentContent from '@/components/JobPosting/JobPostingCard/AdvisorCommentContent'
import { useApp } from '@/hooks/useApp'
import borderLine, { borderSize } from '@/styles/border'
import { align, display } from '@/styles/display'
import { fontWeight } from '@/styles/font'
import spaceStyle from '@/styles/space'
import { isEmpty } from 'lodash'
import { type V1AppColorTheme } from 'mnvm-mypage-app-ts-if'

interface InformationLabelProps {
  isShow: boolean
  text: string
  backgroundColor?: V1AppColorTheme
  textColor: V1AppColorTheme
  opacity?: number
}

const JobPostingCardHeaderPage = ({ component }: any): JSX.Element => {
  const app = useApp()
  const isShowIntroductionDate = !isEmpty(component.introductionDate)

  const InformationLabel = ({
    isShow,
    text,
    backgroundColor,
    textColor,
    opacity = 1
  }: InformationLabelProps): JSX.Element => {
    return isShow ? (
      <Block>
        <Block
          textAlign={align.CENTER}
          backgroundColor={backgroundColor}
          border={{
            size: borderSize.S,
            line: borderLine.Solid,
            color: app.theme.lightGrayColor
          }}
          style={{ opacity }}
        >
          <Text3
            fontWeight={fontWeight.Bold}
            margin={{ vertical: spaceStyle.NONE }}
            padding={{ vertical: spaceStyle.S }}
            textColor={textColor}
          >
            {text}
          </Text3>
        </Block>
      </Block>
    ) : (
      <></>
    )
  }

  return (
    <>
      {isShowIntroductionDate && (
        <Block display={display.FLEX} justifyContent={align.FLEX_END}>
          <Text3 margin={{ all: spaceStyle.NONE }}>
            紹介日：{component.introductionDate}
          </Text3>
        </Block>
      )}
      <InformationLabel
        isShow={component.isConsidering}
        text={'検討中'}
        backgroundColor={app.theme.primaryMainColor}
        textColor={app.theme.whiteColor}
        opacity={0.4}
      />
      <InformationLabel
        isShow={component.isAcceptedOffer}
        text={'内定承諾済'}
        backgroundColor={app.theme.yellowColor}
        textColor={app.theme.mainTextColor}
      />
      <InformationLabel
        isShow={component.isDeclinedApplication}
        text={'応募辞退済'}
        backgroundColor={app.theme.grayBackroundColor}
        textColor={app.theme.subTextColor}
      />
      <InformationLabel
        isShow={component.isRecommended}
        text={'担当アドバイザーのおすすめ'}
        backgroundColor={app.theme.yellowColor}
        textColor={app.theme.mainTextColor}
      />
      <AdvisorCommentContent
        isShow={!isEmpty(component.advisorComment)}
        text={component.advisorComment ?? ''}
        padding={{
          horizontal: spaceStyle.XS,
          vertical: spaceStyle.S
        }}
      />
    </>
  )
}

export default JobPostingCardHeaderPage
